import React, { useEffect, useState } from 'react';
import { ChaveDetailsContainer } from '../Negocios/CaixaAprovacao/ChaveDetails/styles';
import CardDoucmentoSolicitacao from './CardDocumentoSolicitacao';
import { statusSolicitacao, TipoStatusSolicitacao } from '~/constants';
import { Modal } from 'react-bootstrap';
import api from '~/Services/api';
import format from '~/Utils/format';

const SolicitacaoDetalhes = ({ solicitacao, mostrarDetalhes }) => {
  const [digitalizacoes, setDigitalizacoes] = useState([]);
  const [modalHistorico, setModalHistorico] = useState(false);
  const [historico, setHistorico] = useState([]);
  const [historicoLoading, setHistoricoLoading] = useState(false);
  const [historicoError, setHistoricoError] = useState(null);
  useEffect(() => {
    if (!!modalHistorico) {
      const fetchHistorico = async () => {
        try {
          setHistoricoLoading(true);
          setHistoricoError(null);
          const response = await api.buscarLogStatusDespesaProjeto(
            solicitacao.codigo_solicitacao
          );
          setHistorico(response || []);
        } catch (error) {
          setHistoricoError(error?.message || 'Falha ao carregar histórico');
        } finally {
          setHistoricoLoading(false);
        }
      };
      fetchHistorico();
    }
  }, [modalHistorico, solicitacao.codigo_solicitacao]);

  useEffect(() => {
    setDigitalizacoes(solicitacao.digitalizacoes);
  }, [solicitacao]);

  function toggleDigitalizacao(e, digitalizacao) {
    e.stopPropagation();
    mostrarDetalhes(solicitacao, 'digitalizacao', digitalizacao);
  }

  function onThumbCreated(thumb, index) {
    const list = digitalizacoes.filter((d, i) => {
      if (index === i) {
        d.Thumb = thumb;
        d.thumbCreated = true;
      }
      return d;
    });
    setDigitalizacoes(list);
  }

  return (
    <>
      {modalHistorico && (
        <Modal
          show={modalHistorico}
          onHide={() => setModalHistorico(false)}
          size="lg"
          backdrop="static"
          keyboard={false}
          enforceFocus={true}
        >
          <Modal.Header closeButton>
            <Modal.Title>Histórico de Solicitação</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {historicoLoading && (
              <div className="text-center py-4">Carregando...</div>
            )}
            {historicoError && (
              <div className="alert alert-danger" role="alert">
                {historicoError}
              </div>
            )}
            {!historicoLoading && !historicoError && (
              <div>
                {(historico || [])
                  .slice()
                  .sort(
                    (a, b) =>
                      new Date(b.data_registro) - new Date(a.data_registro)
                  )
                  .map((item, idx) => {
                    const statusLabels = {
                      [TipoStatusSolicitacao.Solicitado]: 'Solicitado',
                      [TipoStatusSolicitacao.Processado]: 'Processado',
                      [TipoStatusSolicitacao.Reprovado]: 'Reprovado',
                      [TipoStatusSolicitacao.EmAnalise]: 'Em análise',
                      [TipoStatusSolicitacao.Ajustado]: 'Ajustado',
                    };
                    const statusColors = {
                      [TipoStatusSolicitacao.Solicitado]: 'secondary',
                      [TipoStatusSolicitacao.Processado]: 'success',
                      [TipoStatusSolicitacao.Reprovado]: 'danger',
                      [TipoStatusSolicitacao.EmAnalise]: 'warning',
                      [TipoStatusSolicitacao.Ajustado]: 'info',
                    };
                    const statusLabel = statusLabels[item.status] || '—';
                    const badgeColor = statusColors[item.status] || 'secondary';
                    return (
                      <div
                        key={`${item.codigo}-${idx}`}
                        className="d-flex align-items-start mb-4"
                      >
                        <div className="flex-grow-1">
                          <div className="card shadow-sm">
                            <div className="card-header d-flex justify-content-between align-items-center">
                              <strong>
                                {format.datetime(item.data_registro)}
                              </strong>
                            </div>
                            <div className="card-body">
                              <div className="mb-2">
                                <small className="text-muted">Usuário:</small>{' '}
                                <span>{item.nome_usuario}</span>
                              </div>
                              <div className="mb-2">
                                <small className="text-muted">Status:</small>{' '}
                                <span
                                  className={`badge badge-${badgeColor} ml-1`}
                                >
                                  {statusLabel}
                                </span>
                              </div>
                              {item.justificativa && (
                                <div className="mt-3">
                                  <small className="text-muted d-block">
                                    Justificativa
                                  </small>
                                  <div className="border rounded p-2 bg-light">
                                    {item.justificativa}
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
              </div>
            )}
          </Modal.Body>
        </Modal>
      )}
      <ChaveDetailsContainer
        className="p-2"
        style={{ pointerEvents: modalHistorico ? 'none' : 'auto' }}
      >
        {solicitacao.numero_documento !== 0 && (
          <p className="numero-documento">
            <small>Nº. Doc.:</small> {solicitacao.numero_documento}
          </p>
        )}
        {solicitacao.justificativa && (
          <div>
            <p>
              <strong>
                Justificativa{' '}
                {solicitacao.status_solicitacao === statusSolicitacao.Aprovada
                  ? 'Aprovação'
                  : 'Reprovação'}
              </strong>
            </p>
            <small>
              {solicitacao.justificativa
                .split(/\r\n|\n/)
                .map((linha, index) => (
                  <div key={index}>
                    {linha}
                    <br />
                  </div>
                ))}
            </small>
            <hr />
          </div>
        )}
        {solicitacao.observacoes && (
          <div>
            <p>
              <strong>Observações</strong>
            </p>
            <small>
              {solicitacao.observacoes.split(/\r\n|\n/).map((linha, index) => (
                <div key={index}>
                  {linha}
                  <br />
                </div>
              ))}
            </small>
            <hr />
          </div>
        )}
        {digitalizacoes.some(() => true) && (
          <div>
            <p>
              <strong>
                Digitalizações <span>({digitalizacoes.length})</span>
              </strong>
            </p>
            <div className="CamposDocumentos d-flex card-documento-grande flex-wrap">
              {digitalizacoes.map((digitalizacao, index) => (
                <CardDoucmentoSolicitacao
                  key={index}
                  enableTrash={false}
                  documento={digitalizacao}
                  onRemove={() => {}}
                  onSelectImage={() => {}}
                  onClickDocumento={e => {
                    if (modalHistorico) {
                      e.preventDefault();
                      e.stopPropagation();
                      return;
                    }
                    toggleDigitalizacao(e, digitalizacao);
                  }}
                  onThumbCreated={(thumb, doc) => onThumbCreated(thumb, index)}
                />
              ))}
            </div>
            <hr />
          </div>
        )}
        <div className="d-flex justify-content-end">
          <div>
            <button
              onClick={() => setModalHistorico(true)}
              type="button"
              className="float-right btn btn-link"
            >
              Ver Histórico
            </button>
          </div>
        </div>
      </ChaveDetailsContainer>
    </>
  );
};

export default SolicitacaoDetalhes;
